import React, { FC } from 'react';
import { Modal, ModalClose, ModalFooter, ModalSize, Text, Box } from '@bechtel/gds';
import { Button, ButtonAppearance } from '@bechtel/gds';
import { ModalHeaderStyled, ModalSubHeader, ModalBodyStyled } from './styled';
import { get } from 'lodash';
import { t, Trans } from '@lingui/macro';

interface MultipleCommodityActionProps {
  close: () => void;
  error: any;
}

export const AssignmentError: FC<MultipleCommodityActionProps> = ({ close, error }) => {
  const workpackgeError = get(error, 'assignCrewMembers.erroredWorkPackages');
  const crewMemberError = get(error, 'assignCrewMembers.erroredCrewMemberAssignments');
  return (
    <Modal visible closable onDismiss={close} size={ModalSize.LARGE}>
      <ModalHeaderStyled title={t`Error`}>
        <ModalClose onClick={close}></ModalClose>
      </ModalHeaderStyled>
      <ModalSubHeader>
        <Text family="graphik" size="500" color="grey.1000" weight="600">
          <Trans>Edit Ownership assignment error</Trans>
        </Text>
      </ModalSubHeader>
      <ModalBodyStyled>
        <Box px={{ sm: '500' }} py={{ sm: '600' }}>
          <Text size="500">
            <Trans>There was an error updating workpackage assignment, Please try again later.</Trans>
          </Text>
        </Box>
      </ModalBodyStyled>
      <ModalFooter>
        <Box justifyContent={{ sm: 'flex-end' }}>
          <Box mr={{ sm: '400' }}>
            <Button
              appearance={ButtonAppearance.SECONDARY}
              onClick={close}
              css={`
                padding-left: ${({ theme }) => theme.spacings['600']};
                padding-right: ${({ theme }) => theme.spacings['600']};
              `}
            >
              <Trans>Cancel</Trans>
            </Button>
          </Box>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default AssignmentError;
